import React, { useEffect, useMemo, useState } from 'react';
import middleware from '../../Api/Middleware';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal } from "react-bootstrap";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { BorderedDropDown } from '../../HouseStyle/Components/DropDowns';
import ToastError from '../../Toasts/ToastError';
import ToastSuccess from '../../Toasts/ToastSuccess';
import { formatCurrency } from '../../../utils';

const TerugbetalenModalComponent = (props) => {
    const [chosenPaymentMethod, setChosenPaymentMethod] = useState(1);
    const [paymentMethods, setPaymentMethods] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        const fetchMethods = async () => {
            try {
                const response = await middleware.get('/payment/methods');
                setPaymentMethods(response.data.data || []);
            } catch (error) {
                console.error('Error fetching payment methods:', error);
            }
        };

        fetchMethods();
    }, []);

    useEffect(() => {
        if (props.paybackModalVisible) {
            setChosenPaymentMethod(1);
        } else {
            setChosenPaymentMethod(undefined);
        }
    }, [props.paybackModalVisible]);

    const sameMethodLabel = useMemo(() => {
        // Try to get payment method ID from order.payments first, then fall back to creditation.payment
        let paymentMethodId = null;
        
        if (props.order && props.order.payments && props.order.payments.length > 0) {
            paymentMethodId = props.order.payments[0].payment_method_id;
        } else if (props.creditation && props.creditation.payment && props.creditation.payment.payment_method_id) {
            paymentMethodId = props.creditation.payment.payment_method_id;
        }
        
        if (!paymentMethodId) return 'Betalen op zelfde wijze';
        
        const method = paymentMethods.find(method => method.payment_method_id === paymentMethodId);
        return method ? `Betalen op zelfde wijze (${method.method_name})` : 'Betalen op zelfde wijze';
    }, [paymentMethods, props.creditation, props.order]);

    const closeModal = () => {
        if (isSubmitting) return;
        props.setPaybackModalVisible(false);
        props.setSelectedCreditation && props.setSelectedCreditation(null);
    };

    const completeManualRefund = async () => {
        console.log('completeManualRefund: creditation:', props.creditation);
        let paymentId = props.creditation && props.creditation.payment ? props.creditation.payment.payment_id : undefined;
        // If no payment exists yet, create one with the same method as the original order
        if (!paymentId) {
            let paymentMethodId = null;
            let paymentMethodName = null;
            if (props.order && props.order.payments && props.order.payments.length > 0) {
                paymentMethodId = props.order.payments[0].payment_method_id;
                paymentMethodName = props.order.payments[0].payment_method?.method_name?.toLowerCase();
            }
            if (!paymentMethodId) {
                ToastError('Kan de oorspronkelijke betaalmethode niet vinden.');
                return false;
            }
            // If manual payment (contant/cash or overig/other), just mark as paid
            if (paymentMethodName === 'contant' || paymentMethodName === 'cash' || paymentMethodName === 'overig' || paymentMethodName === 'other') {
                // For manual payment methods, set payment_completed = 1 on the creditation
                if (props.creditation && props.creditation.creditation_id) {
                    try {
                        await middleware.put(`orders/updateCreditationStatus`, {
                            creditation_id: props.creditation.creditation_id,
                            payment_completed: 1
                        });
                        ToastSuccess('Terugbetaling gemarkeerd als voltooid (handmatige betaling).');
                        props.fetchAll && props.fetchAll();
                        props.setPaybackModalVisible(false);
                        props.setSelectedCreditation && props.setSelectedCreditation(null);
                        return true;
                    } catch (err) {
                        ToastError('Kon de creditatie niet als betaald markeren.');
                        return false;
                    }
                } else {
                    ToastError('Geen creditation_id gevonden om de creditatie als betaald te markeren.');
                    return false;
                }
            }
            // Otherwise, create a new payment for this creditation
            const response = await middleware.post('/payment/ideal/start', {
                amount: props.paybackAmount,
                payment_method: paymentMethodId,
                service_code: 'SL-5845-7223',
                return_url: window.location.href,
                test: 1,
                creditation_id: props.creditationId
            });
            paymentId = response.data?.data?.payment_id;
        }
        if (!paymentId) {
            console.error('No payment_id found or created for creditation:', props.creditation);
            ToastError('Geen payment_id gevonden of aangemaakt voor deze creditatie.');
            return false;
        }
        // For online payments, mark payment as PAID immediately
        await middleware.post(`payments/changeStatus/${paymentId}`, {
            status: 'PAID'
        });

        ToastSuccess('Terugbetaling gemarkeerd als voltooid.');
        props.fetchAll && props.fetchAll();
        props.setPaybackModalVisible(false);
        props.setSelectedCreditation && props.setSelectedCreditation(null);
        return true;
    };

    const submit = async () => {
        if (isSubmitting) return;
        try {
            if (!chosenPaymentMethod) {
                ToastError('Geen betaalmethode geselecteerd');
                return;
            }

            setIsSubmitting(true);

            if (Number(chosenPaymentMethod) === 1) {
                const manualHandled = await completeManualRefund();
                if (manualHandled) return;
                setIsSubmitting(false);
                return;
            }
    
            const response = await middleware.post('/payment/ideal/start', {
                amount: props.paybackAmount,
                payment_method: chosenPaymentMethod,
                service_code: 'SL-4153-9581',
                return_url: window.location.href,
                test: 1,
                creditation_id: props.creditationId
            });
            
            
            // Check if the response contains a redirect URL
            if (response.data && response.data.data && response.data.data.ideal_url) {
                window.location.href = response.data.data.ideal_url;
            } else {
                console.error('No redirect URL found in response', response);
            }
            
            props.setPaybackModalVisible(false);
            props.setSelectedCreditation && props.setSelectedCreditation(null);
        } catch (error) {
            console.error('Error initiating payment:', error);
            ToastError('Er ging iets bij het aanmaken van de betaling');
        } finally {
            setIsSubmitting(false);
        }
    }

    return (
        <Modal
            id="modalBlueprint"
            show={props.paybackModalVisible}
            className="colormodals"
            size="lg"
            centered
        >
            <Modal.Header className="modalTop justify-content-between px-5" >
                <h3 className='fw-semibold'>Terugbetalen</h3>
                <button variant="transparent" className='btn' onClick={() => { props.setPaybackModalVisible(false) }}>
                    <FontAwesomeIcon icon={faXmark} className="closeModal" />
                </button>
            </Modal.Header>
            <Modal.Body className="modalCenter">
            </Modal.Body>
            <Modal.Footer className="modalBottom px-5">
                <div className='d-flex flex-column'>
                    <div className='d-flex justify-content-between bottom-line-overzicht mb-4'>
                        <h6 className='fw-semibold'>Totaal bedrag</h6>
                        <h6>{formatCurrency(props.paybackAmount)}</h6>
                    </div>
                    <div className='d-flex justify-content-between bottom-line-overzicht align-items-center mb-4'>
                        <h6 className='fw-semibold mb-3'>Betaalmethode</h6>
                        <div className='mb-3'>
                            <BorderedDropDown
                                size="m"
                                placeholder="Selecteer een betaalmethode"
                                selectedValue={chosenPaymentMethod}
                                setSelectedValue={(value) => setChosenPaymentMethod(value)}
                                options={[
                                    { title: sameMethodLabel, value: 1 },
                                    // { title: 'Betalen met cadeaukaart', value: 2 },
                                    { title: 'Overig', value: 3 },
                                ]}
                            />
                        </div>

                    </div>
                    <div className="d-flex justify-content-end" >
                    <div className="buttonPresetStyle me-3" onClick={closeModal}>Annuleren</div>
                    <div className={`buttonPresetStyle lightGrayStandardButton2 newButtons ${isSubmitting ? 'disabled' : ''}`} onClick={submit}>
                        {isSubmitting ? 'Bezig...' : 'Terugbetalen'}
                    </div>
                    </div>
                </div>
            </Modal.Footer>
        </Modal>
    )
}

export default TerugbetalenModalComponent;
